<template>
	<el-row class="points-show">
		<el-col :span="20">
			串珠素材管理
		</el-col>
		<el-col :span="4">
			<el-button size="mini" type="primary" @click="productAttrAdd(-1)">
				上传素材
			</el-button>
		</el-col>
		<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="5">
				<div class="search-view">
					<div>素材类型：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="scatteredDic">
						<el-option v-for="item in scatteredDicList" :key="item.dicId" :label="item.dicDesc"
							:value="item.dicId" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>内容类型：</div>
					<el-select placeholder="请选择" clearable size="mini" v-model="contentType">
						<el-option v-for="item in contentTypeList" :key="item.dicId" :label="item.dicDesc"
							:value="item.dicId" />
					</el-select>
				</div>
			</el-col>
			<el-col :span="5">
				<div class="search-view">
					<div>商品名称：</div>
					<el-input size="mini" v-model="productName" placeholder="商品名称" clearable />
				</div>
			</el-col>
			<el-col :span="4">
				<el-button size="mini" type="primary" style="margin-left: 10px;" @click="search">搜索</el-button>
			</el-col>
		</el-row>
		<el-col :span="24">
			<el-table :data="tableData" :height="tableHeight">
				<el-table-column prop="matId" label="素材ID" />
				<el-table-column label="素材图片">
					<template slot-scope="scope">
						<el-image
							:src="tableData[scope.$index].matImg.split(',')[0] + '?x-oss-process=image/resize,w_50'"
							:preview-src-list="tableData[scope.$index].matImg.split(',')" fit="fill" />
					</template>
				</el-table-column>
				<el-table-column label="品类" prop="matVarietyText" />
				<el-table-column label="关联商品" prop="productName" />
				<<!-- el-table-column label="素材维度" prop="matRangeText" />
				<el-table-column label="营销阶段" prop="matStageText" />
				<el-table-column label="用户诉求标签" prop="userTypeLabels" />
				<el-table-column label="用户特性标签" prop="userAppealLabels" /> -->
				<el-table-column label="设计理念" prop="sjln" />
				<el-table-column label="产品参数" prop="cpcs" />
				<el-table-column prop="status" label="素材修改" width="280">
					<template slot-scope="scope">
						<el-button size="mini" @click="updateScattered(scope.row)">
							编辑素材
						</el-button>
						<el-button size="mini" @click="getSonMat(scope.row.matId)">
							子素材管理
						</el-button>
						<el-button type="danger" size="mini" icon="el-icon-delete" circle
							@click="removeMat(scope.row.matId, 1)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<!-- 分页小组件 -->
		<el-col :span="24">
			<el-pagination small layout="total,prev, pager, next" :page-size="pageSize" :total="total"
				:current-page.sync="pageNum" @current-change="handleCurrentChange">
			</el-pagination>
		</el-col>
		<!-- 弹窗类组件 -->
		<el-col :span="24">
			<!-- 素材表单 -->
			<el-dialog title="上传素材" :visible.sync="dialogFormVisible" :before-close="closeUpdate" width="32%">
				<el-form :model="form" label-width="100px" label-position="right">
					<el-form-item label="素材首图" prop="matImg">
						<!-- <el-radio-group v-model="radioValue" @input="chooseRadio(1)">
							<el-radio :label="0">本地上传</el-radio>
							<el-radio :label="1">图片库上传</el-radio>
						</el-radio-group> -->
						<el-button @click="chooseRadio(1)" type="primary" size="mini" style="margin-bottom: 10px;">
							图片库上传
						</el-button>
						<el-upload class="hide" :multiple="true" :action="uploadUrl" list-type="picture-card" :limit="1"
							:on-success="getPictrueURL" accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="fileList"
							:on-remove="handleRemove" :on-error="handleError">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					<el-form-item label="选择商品">
						<el-input size="mini" v-model="form.productName" :disabled="true" style="width:215px" />
						<el-button size="mini" @click="table = true">查询商品</el-button>
					</el-form-item>
					<div style="display:flex;width:80%;flex-wrap: wrap;padding: 10px;"
						v-if="form.userTypeLabels.length != 0">
						<el-tag size="mini" style="margin: 2px;" v-for="(item, index) in form.userTypeLabels"
							:key="index">{{ item.dicDesc }}</el-tag>
						<!-- <div v-for="item in form.userTypeLabels" class="typeDiv">{{item.dicDesc}}</div> -->
					</div>
					<el-form-item label="用户特征">
						<el-select v-model="userTypeLabels" size="mini" filterable placeholder="请搜索">
							<el-option v-for="item in userTypeLabelsList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId">
							</el-option>
						</el-select>
						<el-button size="mini" type="primary" round @click="searchFromChange(2)">增加</el-button>
					</el-form-item>
					<!-- 诉求标签 -->
					<div style="display:flex;width:80%;flex-wrap: wrap;padding: 10px;"
						v-if="form.userAppealLabels.length != 0">
						<el-tag size="mini" style="margin: 2px;" v-for="(item, index) in form.userAppealLabels"
							:key="index">{{ item.dicDesc }}</el-tag>
						<!-- <div v-for="item in form.userAppealLabels" class="typeDiv" >{{item.dicDesc}}</div> -->
					</div>
					<el-form-item label="用户诉求">
						<el-select v-model="userAppealLabels" size="mini" filterable placeholder="请搜索">
							<el-option v-for="item in userAppealLabelsList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId">
							</el-option>
						</el-select>
						<el-button size="mini" type="primary" round @click="searchFromChange(1)">增加</el-button>
					</el-form-item>
					<el-form-item label="关联品类">
						<el-select v-model="matVariety" filterable size="mini" @change="searchFromChange(3)"
							placeholder="请搜索">
							<el-option v-for="item in matVarietyList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="素材维度">
						<el-select v-model="matRange" filterable size="mini" @change="searchFromChange(6)"
							placeholder="请搜索">
							<el-option v-for="item in matRangeList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="营销阶段">
						<el-select v-model="matStage" filterable size="mini" @change="searchFromChange(7)"
							placeholder="请搜索">
							<el-option v-for="item in matStageList" :key="item.dicId" :label="item.dicDesc"
								:value="item.dicId">
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="设计理念">
						<el-input size="mini" type="textarea" :rows="2" style="width:315px" v-model="form.sjln" />
					</el-form-item>

					<el-form-item label="产品参数">
						<el-input size="mini" type="textarea" :rows="2" style="width:315px" v-model="form.cpcs" />
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="mini" @click="closeUpdate">取 消</el-button>
					<el-button size="mini" type="primary" @click="addScattered">确 定</el-button>
				</div>
			</el-dialog>
		</el-col>
		<el-col :span="24">
			<el-drawer title="查询商品" :visible.sync="table" direction="rtl" size="50%" style="overflow: auto;">
				<div style="margin-top:20px;margin-bottom:20px;overflow: auto;">
					<span style="margin:20px;">商品名称</span>
					<el-input v-model="keyword" size="mini" style="width:200px;margin-right:20px;" />
					<el-button size="small" @click="searchProduct(true)">
						搜索
					</el-button>
				</div>
				<div>
					<div style="overflow: auto;">
						<el-table :data="tableDataProduct" border style="width: 99%">
							<el-table-column prop="id" label="商品id" align="center" />
							<el-table-column prop="code" label="货号" align="center" />
							<el-table-column label="缩略图" align="center">
								<template slot-scope="scope">
									<el-image
										:src="tableDataProduct[scope.$index].pics.split(',')[0] + '?x-oss-process=image/resize,w_50'"
										fit="fill" :preview-src-list="scope.row.preview" />
								</template>
							</el-table-column>
							<el-table-column prop="name" label="商品名称" align="center" />
							<el-table-column prop="price" label="价格" align="center" />
							<el-table-column label="原料状态" align="center">
								<template slot-scope="scope">
									<span>{{
										tableDataProduct[scope.$index].materielType === 1
											? "成品"
											: "原料"
									}}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作">
								<template slot-scope="scope">
									<el-button type="danger" size="mini" @click="clickProductIs(scope.row)">
										选择
									</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
				<el-pagination class="pagination" background layout="total, sizes,prev, pager, next,jumper"
					:page-size="pageSize2" :page-sizes="[30, 50, 100]" :total="total2" :current-page.sync="pageNum2"
					@size-change="handleSizeChange2" @current-change="handleCurrentChange2" />
			</el-drawer>
		</el-col>
		<!-- 展示子素材位置 -->
		<el-col :span="24">
			<el-drawer title="子素材管理" :visible.sync="sonDrawer" direction="btt" size="92%" :before-close="handleClose">
				<div>
					<el-col :span="20" :offset="2">
						<el-button size="mini" type="primary" @click="chooseMatType('this')">
							上传子素材
						</el-button>
					</el-col>
					<el-col :span="20" :offset="2">
						<el-col :span="20" :offset="2">
							<el-table :data="sonMatData">
								<el-table-column prop="matId" label="素材ID" />
								<el-table-column label="素材图片">
									<template slot-scope="scope">
										<el-image
											:src="sonMatData[scope.$index].matImg.split(',')[0] + '?x-oss-process=image/resize,w_50'"
											:preview-src-list="sonMatData[scope.$index].matImg.split(',')" fit="fill" />
									</template>
								</el-table-column>
								<el-table-column label="素材类型" prop="matTextTypeText" />
								<el-table-column prop="status" label="素材修改" width="280">
									<template slot-scope="scope">
										<el-button size="mini" @click="updateScattered(scope.row, 'son')">
											编辑
										</el-button>
										<el-button type="danger" size="mini" icon="el-icon-delete" circle
											@click="removeSonMat(scope.row.matId, 1)"></el-button>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-col>
					<el-col :span="24">
						<el-drawer title="增加/编辑子素材" size="92%" :append-to-body="true" :before-close="closeSonUpdate"
							:visible.sync="innerSonDrawer">
							<div>
								<el-col :span="20" :offset="2">
									<el-form :model="form" style="width:46%" label-width="160px" label-position="right">
										<el-form-item label="请先选择子素材标签：">
											<el-select v-model="form.matType" filterable size="mini" placeholder="请搜索"
												:change="hexin()">
												<el-option v-for="item in sonMatList" :key="item.dicId"
													:label="item.dicDesc" :value="item.dicId">
												</el-option>
											</el-select>
										</el-form-item>
										<div v-if="!ishexin">
											<!-- 图片类的 -->
											<el-form-item label="上传图片" prop="matImg" v-if="sonTextOrImg == 'img'">
												<!-- <el-radio-group v-model="radioValue" @input="chooseRadio(10)">
													<el-radio :label="0">本地上传</el-radio>
													<el-radio :label="1">图片库上传</el-radio>
												</el-radio-group> -->
												<el-button @click="chooseRadio(9)" type="primary" size="mini"
													style="margin-bottom: 10px;">
													图片库上传
												</el-button>
												<el-upload class="hide" :multiple="true" :action="uploadUrl"
													list-type="picture-card" :limit="9" :on-success="getPictrueURL"
													accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="fileList"
													:on-remove="handleRemove" :on-error="handleError">
													<i class="el-icon-plus"></i>
												</el-upload>
											</el-form-item>
											<el-form-item label="备注" v-if="sonTextOrImg == 'img'">
												<el-input type="textarea" :rows="5" placeholder="请输入内容"
													v-model="form.matNote">
												</el-input>
											</el-form-item>
											<!-- 文章类的 -->
											<el-form-item label="文章标题" v-if="sonTextOrImg == 'text'">
												<el-input type="textarea" :rows="1" placeholder="请输入内容"
													v-model="form.matNote">
												</el-input>
											</el-form-item>
											<el-form-item label="文章首图" prop="matImg" v-if="sonTextOrImg == 'text'">
												<el-button @click="chooseRadio(1)" type="primary" size="mini"
													style="margin-bottom: 10px;">
													图片库上传
												</el-button>
												<el-upload class="hide" :multiple="true" :action="uploadUrl"
													list-type="picture-card" :limit="1" :on-success="getPictrueURL"
													accept=".jpg,.png,.jpeg,.mp4,.avi" :file-list="fileList"
													:on-remove="handleRemove" :on-error="handleError">
													<i class="el-icon-plus"></i>
												</el-upload>
											</el-form-item>
											<el-form-item label="文章内容" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.matInfo" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
										</div>
										<div v-else style="width: 700px">
											<el-form-item label="设计原理——组合功效" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.design" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
											<el-form-item label="应用细分场景" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.scene" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
											<el-form-item label="针对人群特写" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.crowd" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
											<el-form-item label="解决问题原理" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.principle" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
											<el-form-item label="原理佐证" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.prove" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
											<el-form-item label="特别之处" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.special" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
											<el-form-item label="产品特写" v-if="sonTextOrImg == 'text'">
											</el-form-item>
											<el-form-item label="" v-if="sonTextOrImg == 'text'">
												<wangeditor v-model="form.details" style="width:100%;margin:0;"
													ref="wangeditor" />
											</el-form-item>
										</div>
										<el-form-item>
											<el-button size="mini" @click="closeSonUpdate">取 消</el-button>
											<el-button size="mini" type="primary" @click="addSonMat">确 定
											</el-button>
										</el-form-item>
									</el-form>
								</el-col>
							</div>
						</el-drawer>

					</el-col>
				</div>
			</el-drawer>
		</el-col>
		<!-- 增加图片的窗口 -->
		<el-col :span="24">

		</el-col>
		<el-drawer title="选择图片" :visible.sync="isSelectPicture" direction="rtl" size="40%">
			<SelectPicture :imgNum="imgNum" @imgList='getImg' />
		</el-drawer>
	</el-row>
</template>
<script>
	import httpClient from "../../../util/request.js";
	import wangeditor from '../../../components/wangEditor/wangEditor.vue';
	import SelectPicture from '../../../components/SelectPicture/index.vue'
	export default {
		components: {
			wangeditor,
			SelectPicture
		},
		data() {
			return {
				radioValue: 0,
				isSelectPicture: false,
				imgNum: 1,
				ishexin: false,
				// 子素材参数位置
				sonDrawer: false,
				innerSonDrawer: false,
				sonMatList: [],
				sonMatData: [],
				//   子素材要上传文字还是图片
				sonTextOrImg: '',
				pid: -1, //当前操作的Pid
				// 父级素材参数位置
				tableHeight: window.innerHeight - 300,
				dialogFormVisible: false,
				// uploadUrl:  "https://pro.xinian727.com/api/product/common/uploadPicture",
				uploadUrl: httpClient.imgUrl,
				fileList: [], // 商品图片上传控件图片数据源
				dialogDisplay: false, // 上传图片弹窗
				dialogImageUrl: "", //上传图片控件预览url
				// FORM表单
				form: {
					matId: "", //素材的ID
					matImg: "", //图片或视频地址
					matInfo: "", //文案或者话术
					userTypeLabels: [], //用户特征标签组
					userAppealLabels: [], //用户诉求标签组
					matVariety: "", //关联品类
					matType: "",
					matRange: "",
					matStage: "",
					wearWay: "", //佩戴类型
					productName: "请查询商品并选择", //商品名称
					productId: 0, //商品ID
					matStyle: 2,
					status: 0,
					matNote: "",
					contentType: "", //内容类型
					stoneType: "", //石头类型
					designerCode: "", //设计师
					referencePrice: "", //参考价格,
					// 父级ID
					parentId: -1,
					sjln: '',
					cpcs: '',
					//核心
					design: "",
					scene: "",
					crowd: "",
					principle: "",
					prove: "",
					special: "",
					details: "",
				},
				formLabelWidth: "80px",
				loading: false,
				tableData: [],
				tableDataProduct: [],
				pageNum: 1,
				pageSize: 10,
				pageNum2: 1,
				pageSize2: 15,
				total: null,
				total2: null,
				productName: '',
				// 素材的类型
				matStyle: 2,
				//内容类型  999999999999
				contentTypeList: [],
				contentType: "",
				//石头类型 11 11 11 11 11
				stoneTypeList: [],
				stoneType: "",
				//设计师  10 10 10 10 10
				designerCodeList: [],
				designerCode: "",
				// 佩戴类型
				wearWayList: [],
				wearWay: "",
				// 素材的字典列表
				scatteredDicList: [],
				scatteredDic: "",
				//1-用户诉求标签组
				userAppealLabelsList: [],
				userAppealLabels: "",
				searchUserAppea: [],
				//2-用户特性标签组
				userTypeLabelsList: [],
				userTypeLabels: "",
				searchUserType: [],
				//3-品类组
				matVarietyList: [],
				matVariety: "",
				//6-素材维度
				matRangeList: [],
				matRange: "",
				//7-营销阶段
				matStageList: [],
				matStage: "",
				// 4-选中的增加文章标签
				selectDicList: [],
				selectDic: "",
				table: false,
				keyword: "",
				referencePrice: "",
				pickerOptions: {
					shortcuts: [{
							text: "最近一周",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近一个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit("pick", [start, end]);
							},
						},
						{
							text: "最近三个月",
							onClick(picker) {
								const end = new Date();
								const start = new Date();
								start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit("pick", [start, end]);
							},
						},
					],
				},
				beginAndEndTime: "",
			};
		},
		mounted() {
			this.getScatteredDic();
			this.getScatteredDicAll();
		},
		methods: {
			chooseRadio(num) {
				this.imgNum = num
				this.isSelectPicture = true
			},
			getImg(e) {
				this.form.matImg = ''
				this.form.matImg = e
				this.fileList = []
				e.split(',').forEach(item => {
					this.fileList.push({
						url: item
					})
				})
				this.isSelectPicture = false
			},
			addRelation(matId) {
				let url =
					`/api/plant/groupMaterial/insertUpdateLog?matId=${matId}`
				this.$http.post(url, {}).then(res => {
					console.log(res.data);
				})
			},
			//子素材的查询以及上传操作
			// 查询子素材
			getSonMat(pid) {
				this.loading = true;
				let url = "/api/source/matCascadeMat/listPage";
				url = url + "?pageNum=" + 0 + "&pageSize=" + 100;
				var params = {
					parentId: pid,
					status: 0
				};
				params.matType = this.scatteredDic;
				return this.$http
					.post(url, params)
					.then((res) => {
						if (res.data.status == 0) {
							this.sonMatData = res.data.data.list;
							this.pid = pid;
							this.sonDrawer = true;
						} else {
							this.$message.error("发生了一些错误");
						}
					})
					.catch((error) => {
						console.log(error);
					})
					.finally((res) => {
						this.loading = false;
					});
			},
			addSonMat() {
				var params = this.null2str(this.form);
				params.matStyle = this.matStyle;
				params.parentId = this.pid;
				this.loading = true;
				// 数据重组
				// if (params.matImg.length > 0 && params.matId == "") {
				// 	params.matImg = params.matImg.substr(0, params.matImg.length - 1);
				// }
				var userAppeal = "";
				params.userAppealLabels.forEach((element) => {
					userAppeal += element.dicId + ",";
				});
				var userType = "";
				params.userTypeLabels.forEach((element) => {
					userType += +element.dicId + ",";
				});
				if (userType.length > 0) {
					params.userTypeLabels = userType.substr(0, userType.length - 1);
				} else {
					params.userTypeLabels = userType;
				}
				if (userAppeal.length > 0) {
					params.userAppealLabels = userAppeal.substr(0, userAppeal.length - 1);
				} else {
					params.userAppealLabels = userAppeal;
				}
				// return
				if (params.matId == "") {
					params.memberId = this.$store.state.memberId;
					// 新增就完事了嗷铁子
					return this.$http
						.post("/api/source/matCascadeMat/add", params)
						.then((res) => {
							if (res.data.status == 0) {
								this.$message.success("增加成功");
								this.addRelation(this.pid)
							} else {
								this.$message.error("增加失败");
							}
						})
						.finally((res) => {
							if (this.$refs.wangeditor) {
								this.$refs.wangeditor.clearText();
							}
							this.innerSonDrawer = false;
							this.resetFrom();
							this.fileList = [];
							this.loading = false;
							this.resetSearch();
							this.getSonMat(this.pid);
						});
				}
				if (params.matId != "") {
					return this.$http
						.post("/api/source/matCascadeMat/update", params)
						.then((res) => {
							if (res.data.status == 0) {
								this.$message.success("修改成功");
								this.addRelation(this.pid)
							} else {
								this.$message.error("修改失败");
							}
						})
						.finally((res) => {
							if (this.$refs.wangeditor) {
								this.$refs.wangeditor.clearText();
							}
							this.innerSonDrawer = false;
							this.resetFrom();
							this.fileList = [];
							this.loading = false;
							this.resetSearch();
							this.getSonMat(this.pid);
						});
				}
			},
			chooseMatType(pid) {
				if (pid == 'this') {
					pid = this.pid;
				}
				this.$confirm('请选择要增加的素材类型?', '提示', {
					confirmButtonText: '文章',
					cancelButtonText: '图片',
					type: 'info',
					center: true,
					closeOnClickModal: false,
					distinguishCancelAndClose: true
				}).then(() => {
					// 文章
					this.sonTextOrImg = 'text';
					this.getSetSonMat(202);
					this.innerSonDrawer = true;
				}).catch((action) => {
					if (action == 'cancel') {
						// 图片
						this.sonTextOrImg = 'img';
						this.getSetSonMat(197);
						this.innerSonDrawer = true;
					}
				});
			},
			// 获取串珠子素材标签旗帜
			getSetSonMat(pid) {
				this.$http
					.get("/api/source/matDic/selectByParentId?pid=" + pid, {})
					.then((res) => {
						var typeList = [{
							dicId: "",
							dicDesc: "请选择",
							dicId: ""
						}];
						this.sonMatList = typeList.concat(res.data.data);
					})
			},
			handleClose() {
				this.sonDrawer = false
			},
			handleSonClose() {
				this.innerSonDrawer = false
			},
			modeChange() {
				console.log(this.beginAndEndTime);
			},
			handleReferencePrice(value) {
				this.form.referencePrice = value;
			},
			hexin() {
				if (this.form.matType == 203) {
					this.ishexin = true
					console.log("当前是核心讲解")
				} else {
					this.ishexin = false
				}
			},
			// update素材
			updateScattered(rowData, son) {
				console.log(son);
				// 初始化标签数据
				this.resetFrom();
				this.fileList = [];
				var row = this.cloneData(rowData);
				this.form.matImg = row.matImg
				if (son) {
					row.matImg.split(",").forEach((item) => {
						this.fileList.push({
							url: item,
						});
					});
				} else {
					this.fileList.push({
						url: row.matImg,
					});
				}
				// 把数列数据进行重组
				row.userTypeLabels = row.userTypeLabelLi;
				row.userAppealLabels = row.userAppealLabelLi;
				var newUserTypeLabels = [];
				row.userTypeLabelLi.forEach(element => {
					console.log(element)
					newUserTypeLabels.push({
						dicDesc: element.labelText,
						dicId: element.labelValue
					})
				})
				row.userTypeLabels = newUserTypeLabels;
				var newUserAppealLabels = [];
				row.userAppealLabelLi.forEach(element => {
					console.log(element)
					newUserAppealLabels.push({
						dicDesc: element.labelText,
						dicId: element.labelValue
					})
				})
				row.userAppealLabels = newUserAppealLabels;
				this.form = row;
				// 进行数据放置
				this.contentType = this.form.contentType;
				this.stoneType = this.form.stoneType;
				this.designerCode = this.form.designerCode;

				this.matVariety = this.form.matVariety;
				this.matRange = this.form.matRange;
				this.matStage = this.form.matStage;
				this.wearWay = this.form.wearWay;
				this.selectDic = this.form.matType;
				this.referencePrice = this.form.referencePrice;

				if ('son' == son) {
					this.hexin()
					if (row.matInfo != null && row.matInfo != "") {
						this.sonTextOrImg = 'text';
						this.getSetSonMat(202);
						this.innerSonDrawer = true;
					} else {
						this.sonTextOrImg = 'img';
						this.getSetSonMat(197);
						this.innerSonDrawer = true;
					}
				} else {
					this.dialogFormVisible = true;
				}
				console.log(this.form);
			},
			closeUpdate() {
				this.resetFrom();
				this.resetSearch();
				this.fileList = [];
				this.dialogFormVisible = false;
			},
			closeSonUpdate() {
				if (this.$refs.wangeditor) {
					this.$refs.wangeditor.clearText();
				}
				this.resetFrom();
				this.resetSearch();
				this.fileList = [];
				this.innerSonDrawer = false;
			},

			null2str(data) {
				for (let x in data) {
					if (x != 'userAppealLabelIds' && x != 'userTypeLabelIds') {
						if (data[x] == null) { // 如果是null 把直接内容转为 ''
							data[x] = '';
						}
					}
				}
				return data;
			},
			// 这就可以进行上传操作了铁子
			addScattered() {
				var params = this.null2str(this.form);
				console.log(params);
				// return false
				params.matStyle = this.matStyle;
				this.loading = true;
				// 数据重组
				// if (params.matImg.length > 0 && params.matId == "") {
				// 	params.matImg = params.matImg.substr(0, params.matImg.length - 1);
				// }
				var userAppeal = "";
				params.userAppealLabels.forEach((element) => {
					userAppeal += element.dicId + ",";
				});
				var userType = "";
				params.userTypeLabels.forEach((element) => {
					userType += +element.dicId + ",";
				});
				if (userType.length > 0) {
					params.userTypeLabels = userType.substr(0, userType.length - 1);
				} else {
					params.userTypeLabels = userType;
				}
				if (userAppeal.length > 0) {
					params.userAppealLabels = userAppeal.substr(0, userAppeal.length - 1);
				} else {
					params.userAppealLabels = userAppeal;
				}
				// console.log("上传参数",params);
				// return
				if (params.matId == "") {
					params.memberId = this.$store.state.memberId;
					// 新增就完事了嗷铁子
					return this.$http
						.post("/api/source/matCascadeMat/add", params)
						.then((res) => {
							if (res.data.status == 0) {
								this.$message.success("增加成功");
								this.addRelation(this.pid)
							} else {
								this.$message.error("增加失败");
							}
						})
						.finally((res) => {
							this.dialogFormVisible = false;
							this.resetFrom();
							this.fileList = [];
							this.loading = false;
							this.resetSearch();
							this.getList();
						});
				}
				if (params.matId != "") {
					return this.$http
						.post("/api/source/matCascadeMat/update", params)
						.then((res) => {
							if (res.data.status == 0) {
								this.$message.success("修改成功");
								this.addRelation(this.pid)
							} else {
								this.$message.error("修改失败");
							}
						})
						.finally((res) => {
							this.dialogFormVisible = false;
							this.resetFrom();
							this.fileList = [];
							this.loading = false;
							this.resetSearch();
							this.getList();
						});
				}
			},
			resetFrom() {
				this.form = {
					matId: "", //素材的ID
					matImg: "", //图片或视频地址
					matInfo: "", //文案或者话术
					userTypeLabels: [], //用户特征标签组
					userAppealLabels: [], //用户诉求标签组
					matVariety: "", //关联品类
					matType: "",
					matRange: "",
					matStage: "",
					wearWay: "", //佩戴类型
					productName: "请查询商品并选择", //商品名称
					productId: 0, //商品ID
					matStyle: 2,
					status: 0,
					matNote: "",
					contentType: "", //内容类型
					stoneType: "", //石头类型
					designerCode: "", //设计师
					referencePrice: "",
					// 父级ID
					sjln: '',
					cpcs: '',
					parentId: -1
				};
			},
			resetSearch() {
				this.wearWay = "";
				// 素材的字典列表
				this.scatteredDic = "";
				//1-用户诉求标签组
				this.searchUserAppea = [];
				//2-用户特性标签组
				this.searchUserType = [];
				//3-品类组
				this.matVariety = "";
				//6-素材维度
				this.matRange = "";
				//7-营销阶段
				this.matStage = "";
				// 4-选中的增加文章标签
				this.selectDic = "";
				this.beginAndEndTime = [];
				//内容类型  999999999999
				this.contentTypeList = [];
				this.contentType = "";
				//石头类型 11 11 11 11 11
				this.stoneTypeList = [];
				this.stoneType = "";
				//设计师  10 10 10 10 10
				this.designerCodeList = [];
				this.designerCode = "";
				this.referencePrice = "";
			},
			searchFromChange(id) {
				let typeElement = null;
				switch (id) {
					case 1:
						this.userAppealLabelsList.forEach((element) => {
							if (element.dicId == this.userAppealLabels) {
								typeElement = element;
							}
						});
						if (typeElement != null) {
							let indexIf = 0;
							this.form.userAppealLabels.forEach((element) => {
								if (element.dicId == typeElement.dicId) {
									indexIf++;
								}
							});
							indexIf == 0 ?
								this.form.userAppealLabels.push(typeElement) :
								this.$message.error("已存在该标签");
						}
						break;
					case 2:
						this.userTypeLabelsList.forEach((element) => {
							if (element.dicId == this.userTypeLabels) {
								typeElement = element;
							}
						});
						if (typeElement != null) {
							let indexIf = 0;
							this.form.userTypeLabels.forEach((element) => {
								if (element.dicId == typeElement.dicId) {
									indexIf++;
								}
							});
							indexIf == 0 ?
								this.form.userTypeLabels.push(typeElement) :
								this.$message.error("已存在该标签");
						}
						break;
					case 3:
						this.form.matVariety = this.matVariety;
						break;
					case 6:
						this.form.matRange = this.matRange;
						break;
					case 7:
						this.form.matStage = this.matStage;
						break;
					case 8:
						this.form.wearWay = this.wearWay;
						break;
						// 999999999999
					case 9:
						this.form.contentType = this.contentType;
						break;
						// 10 10 10
					case 10:
						this.form.designerCode = this.designerCode;
						break;
						// 11 11 11
					case 11:
						this.form.stoneType = this.stoneType;
						break;
					case 4:
						this.form.matType = this.selectDic;
						break;
					default:
						break;
				}
			},
			productAttrAdd(pid) {
				// 打开增加素材的窗口
				this.resetSearch();
				this.resetFrom();
				this.getScatteredDicAll();
				this.fileList = [];
				this.form.parentId = pid;
				this.dialogFormVisible = true;
			},
			// 搜索
			search() {
				this.loading = true;
				let url = "/api/source/matCascadeMat/listPage";
				url = url + "?pageNum=" + 0 + "&pageSize=" + this.pageSize;

				// 对数据进行组装
				var userTypeLabels = "";
				var userAppealLabels = "";
				if (this.searchUserType.length > 0) {
					this.searchUserType.forEach((element) => {
						userTypeLabels += element + ",";
					});
					userTypeLabels = userTypeLabels.substr(0, userTypeLabels.length - 1);
				}
				if (this.searchUserAppea.length > 0) {
					this.searchUserAppea.forEach((element) => {
						userAppealLabels += element + ",";
					});
					userAppealLabels = userAppealLabels.substr(
						0,
						userAppealLabels.length - 1
					);
				}
				var beginTime = "";
				var endTime = "";
				if (this.beginAndEndTime.length > 0) {
					beginTime = this.beginAndEndTime[0];
					endTime = this.beginAndEndTime[1];
				}
				var params = {
					matStyle: this.matStyle,
					matStage: this.matStage,
					matRange: this.matRange,
					matVariety: this.matVariety,
					userTypeLabels: userTypeLabels,
					userAppealLabels: userAppealLabels,
					wearWay: this.wearWay,
					beginTime: beginTime,
					endTime: endTime,
					contentType: this.contentType,
					parentId: -1,
					productName: this.productName,
					status: 0
				};
				params.matType = this.scatteredDic;
				return this.$http.post(url, params).then((res) => {
						res.data.data.list.forEach((element) => {
							element.userTypeLabels = "";
							element.userAppealLabels = "";
							element.userAppealLabelLi.forEach((element2) => {
								element.userAppealLabels =
									element2.labelText + " | " + element.userAppealLabels;
							});
							element.userTypeLabelLi.forEach((element2) => {
								element.userTypeLabels =
									element2.labelText + " | " + element.userTypeLabels;
							});
							var subString = element.matInfo.length < 31 ? element.matInfo.length : 30;
							element.matInfoTitle = element.matInfo.substr(0, subString) + "......";
						});
						console.log(res.data.data.list);
						this.tableData = res.data.data.list;
						this.total = res.data.data.total;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally((res) => {
						this.loading = false;
					});
			},
			getList() {
				this.loading = true;
				let url = "/api/source/matCascadeMat/listPage";
				url = url + "?pageNum=" + this.pageNum + "&pageSize=" + this.pageSize;
				//
				var userTypeLabels = "";
				var userAppealLabels = "";
				if (this.searchUserType.length > 0) {
					this.searchUserType.forEach((element) => {
						userTypeLabels += element + ",";
					});
					userTypeLabels = userTypeLabels.substr(0, userTypeLabels.length - 1);
				}
				if (this.searchUserAppea.length > 0) {
					this.searchUserAppea.forEach((element) => {
						userAppealLabels += element + ",";
					});
					userAppealLabels = userAppealLabels.substr(
						0,
						userAppealLabels.length - 1
					);
				}

				var beginTime = "";
				var endTime = "";
				if (this.beginAndEndTime.length > 0) {
					beginTime = this.beginAndEndTime[0];
					endTime = this.beginAndEndTime[1];
				}
				var params = {
					matStyle: this.matStyle,
					matStage: this.matStage,
					matRange: this.matRange,
					matVariety: this.matVariety,
					userTypeLabels: userTypeLabels,
					userAppealLabels: userAppealLabels,
					wearWay: this.wearWay,
					beginTime: beginTime,
					endTime: endTime,
					contentType: this.contentType,
					parentId: -1,
					productName: this.productName,
					status: 0
				};
				params.matType = this.scatteredDic;
				return this.$http
					.post(url, params)
					.then((res) => {
						res.data.data.list.forEach((element) => {
							element.userTypeLabels = "";
							element.userAppealLabels = "";
							element.userAppealLabelLi.forEach((element2) => {
								element.userAppealLabels =
									element2.labelText + " | " + element.userAppealLabels;
							});
							element.userTypeLabelLi.forEach((element2) => {
								element.userTypeLabels =
									element2.labelText + " | " + element.userTypeLabels;
							});
							var subString =
								element.matInfo.length < 31 ? element.matInfo.length : 30;
							element.matInfoTitle =
								element.matInfo.substr(0, subString) + "......";
						});
						console.log(res.data.data.list);
						this.tableData = res.data.data.list;
						this.total = res.data.data.total;
					})
					.catch((error) => {
						console.log(error);
					})
					.finally((res) => {
						this.loading = false;
					});
			},

			// 移除素材
			removeMat(id, status) {
				this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.post('/api/source/matCascadeMat/update', {
						matId: id,
						status: status
					}).then(res => {
						if (res.data.status === 0) {
							this.$message({
								type: 'success',
								message: '移除完成'
							});
							this.search();
						} else {
							this.$message({
								type: 'error',
								message: '修改失败'
							});
						}
					}).catch(error => {
						console.log(error);
					});
				});
			},
			// 移除素材
			removeSonMat(id, status) {
				this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true
				}).then(() => {
					this.$http.post('/api/source/matCascadeMat/update', {
						matId: id,
						status: status
					}).then(res => {
						if (res.data.status === 0) {
							this.$message({
								type: 'success',
								message: '移除完成'
							});
							this.getSonMat(this.pid);
						} else {
							this.$message({
								type: 'error',
								message: '修改失败'
							});
						}
					}).catch(error => {
						console.log(error);
					});
				});
			},
			// 获取一系列的标签
			getScatteredDicAll() {
				this.loading = true;
				// 请求1 2 3 6 7
				var dicTypeS = [1, 2, 3, 5, 6, 7, 8, 9, 10, 11];
				var dicTypeValue = {
					1: 180,
					2: 179,
					3: 181,
					5: 182,
					6: 183,
					7: 184,
					8: 185,
					9: 186,
					10: 187,
					11: 188
				};
				dicTypeS.forEach((element) => {
					this.$http
						.get("/api/source/matDic/selectByParentId?pid=" + dicTypeValue[element], {})
						.then((res) => {
							switch (element) {
								case 1:
									this.userAppealLabelsList = res.data.data;
									break;
								case 2:
									this.userTypeLabelsList = res.data.data;
									break;
								case 3:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.matVarietyList = typeList.concat(res.data.data);
									break;
								case 5:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.scatteredDicList = typeList.concat(res.data.data);
									this.selectDicList = res.data.data;
									break;
								case 6:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.matRangeList = typeList.concat(res.data.data);
									break;
								case 7:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.matStageList = typeList.concat(res.data.data);
									break;
								case 8:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.wearWayList = typeList.concat(res.data.data);
									break;
								case 9:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.contentTypeList = typeList.concat(res.data.data);
									break;
								case 10:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.designerCodeList = typeList.concat(res.data.data);
									break;
								case 11:
									var typeList = [{
										dicId: "",
										dicDesc: "请选择",
										dicId: ""
									}];
									this.stoneTypeList = typeList.concat(res.data.data);
									break;
							}
						})
						.finally((res) => {});
				});
				this.loading = false;
			},
			getScatteredDic() {
				this.tableData = [];
				this.search();
			},
			clickProductIs(product) {
				this.form.productId = product.id;
				this.form.productName = product.name;
				this.table = false;
			},
			// 获取图片地址，调用接口后端返回上传地址
			getPictrueURL(response, file, fileList) {
				if (this.sonTextOrImg == 'text') {
					this.form.matImg = response.data
				} else if (this.sonTextOrImg == 'img') {
					if (this.form.matImg[this.form.matImg.length - 1] == ",") {
						this.form.matImg += response.data + ",";
					} else {
						if (this.form.matImg.length > 0) {
							this.form.matImg += "," + response.data + ",";
						} else {
							this.form.matImg += response.data + ",";
						}
					}
				} else {
					this.form.matImg = response.data
				}
			},
			// 图片预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogDisplay = true;
			},

			// 图片预览dialog关闭时的回调
			imagePrevClosed() {
				this.dialogImageUrl = "";
			},
			// 图片上传框删除一个图片
			handleRemove(file, fileList) {
				let files = this.form.matImg.split(",");
				files.splice(files.indexOf(file.url), 1);
				this.form.matImg = files.length === 0 ? "" : files.join(",");
			},
			handleSuccess(res, file, fileList) {
				if (res.status === 0) {
					this.$message({
						message: "上传成功！",
						type: "success",
					});
					this.fileList = [];
				} else {
					this.$message({
						message: res.msg,
						type: "error",
					});
				}
			},
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.getList();
			},
			// 查询商品
			searchProduct(ischange) {
				if (ischange) {
					this.pageNum = 1;
				}
				let url = "/api/product/product/product";
				let uploadUrl = httpClient.uploadUrl
				console.log(uploadUrl, 'https://pro.xinian727.com');
				return this.$http
					.get(url, {
						params: {
							pageNum: this.pageNum,
							pageSize: this.pageSize,
							keyword: this.keyword,
							// status:''
							sort: -1,
						},
					})
					.then((res) => {
						this.tableDataProduct = res.data.data.list;
						this.tableDataProduct.forEach((item, index) => {
							item.preview = [];
							item.preview = item.pics.split(",");
						});
						this.total2 = res.data.data.total;
					});
			},
			handleSizeChange2(val) {
				this.pageSize = val;
				this.searchProduct(false);
			},
			handleCurrentChange2(val) {
				this.pageNum = val;
				this.searchProduct(false);
			},
			cloneData(obj) {
				//判断是对象，就进行循环复制
				if (typeof obj === "object" && obj != null) {
					// 区分是数组还是对象，创建空的数组或对象
					var o =
						Object.prototype.toString.call(obj).slice(8, -1) === "Array" ? [] : {};
					for (var k in obj) {
						// 如果属性对应的值为对象，则递归复制
						if (typeof obj[k] === "object" && obj[k] != null) {
							o[k] = this.cloneData(obj[k]);
						} else {
							o[k] = obj[k];
						}
					}
				} else {
					//不为对象，直接把值返回
					return obj;
				}
				return o;
			},
			handleError(err, file, fileList) {
				err = err + "a";
				if (err.search("413") != -1) {
					this.$message.error("抱歉，文件过大，无法上传");
				} else {
					this.$message.error("抱歉，上传文件失败，请稍等片刻再次尝试");
				}
			},
		},
	};
</script>
<style lang="less" scoped>
	.productAttrAddBox {
		width: 300px;
	}

	/deep/.el-drawer__open .el-drawer.rtl {
		overflow: auto;
	}

	.pagination {
		margin-left: 50%;
		margin-top: 20px;
		z-index: 2;
		transform: translateX(-50%);
	}

	.typeDiv {
		padding: 2px 8px;
		margin: 1px;
		font-size: 12px;
		height: 14px;
		line-height: 14px;
		background: #808080ad;
		color: white;
		border-radius: 11px;
	}

	/deep/.el-drawer {
		overflow: auto;
	}

	/deep/.el-drawer__body {
		overflow: auto;
	}

	/deep/.el-table .cell {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 4;
		line-clamp: 4;
		-webkit-box-orient: vertical;
	}

	/deep/.el-input {
		width: auto;
	}

	/deep/.el-button--mini,
	.el-button--mini.is-round {
		margin-left: 15px;
	}

	/deep/.el-input {
		height: auto;
	}

	/deep/.hide .el-upload--picture-card {
		display: none;
	}
</style>
